import * as config from 'config';
let isAdmin = false;

// Google analytics
window.ga =
  window.ga ||
  function () {
    (ga.q = ga.q || []).push(arguments);
  };
ga.l = +new Date();

const createPlanhat = (user, merchant, isAdmin) => {
  return (action: any, info: any = {}) => null;
};

export const eventTypes = {
  synonymGroupCreated: 'synonym-group_created',
  synonymSuggestionGroupAccepted: 'synonym-suggestion-group_accepted',
  synonymSuggestionGroupRejected: 'synonym-suggestion-group_rejected',
  bannerCreated: 'banner_created',
  filterAdded: 'filter_added',
  filterRemoved: 'filter_removed',
  outOfStockBehaviorChanged: 'out-of-stock-behavior_changed',
  productPinCreated: 'product-pin_created',
  lookAndFeelPublished: 'look-and-feel-published',
  tourStarted: 'tour-started',
  tourFinished: 'tour-finished',
  tourStepOneCompleted: 'tour-step-one-completed',
  tourStepTwoCompleted: 'tour-step-two-completed',
};

export const pageView = (page: string) => {
  if (__DEVELOPMENT__ || isAdmin) return;
  window.ga('set', { page });
  window.ga('send', 'pageview', page);
};

export const sendEvent = (event: string, data) => {
  if (__DEVELOPMENT__) return;
  if (isAdmin) return;
};

export const init = (user, merchant) => {
  if (__DEVELOPMENT__) return;

  const userId = user.id;
  const merchantID = merchant.merchantID || 'null';

  /**
   * Disable analytics for admin user
   */

  const isAdmin = merchant && merchant.role === 'admin';

  if (isAdmin) return;

  window.planhat = createPlanhat(user, merchant, isAdmin);

  window.ga('create', config.tracking.gaAppId, { userId: user.id });
};
